import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ show }) => {
  return (
    <>
      {show && (
        <div className="_loading_overlay_overlay css-df17o1 _loading-overlay-transition-enter-done load__background_alfa">
          <svg className="load__icon">
            <path
              fill="#5b346d"
              d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
            />
          </svg>
        </div>
      )}
    </>
  );
};

Loading.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default Loading;
